import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { WizardForm } from "./wizardForm";
import { AccountForm } from "./accountForm";
import { PlanzoneForm } from "./planzoneForm";
import styles from "./styles.scss";

function Form({ formData, error, editForm, submitForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <WizardForm
        submitPlaceholder={
          formData.hasRequestedPlanzoneCreation
            ? t("accountCreationConfirmation.submit.createPlanzone")
            : t("accountCreationConfirmation.submit.createAccount")
        }
        steps={
          formData.hasRequestedPlanzoneCreation
            ? [
                {
                  component: (
                    <AccountForm
                      formData={formData}
                      error={error}
                      editForm={editForm}
                    />
                  ),
                  title: t("accountCreationConfirmation.accountTitle"),
                  placeholder: {
                    next: t("accountCreationConfirmation.submitAccountForm"),
                  },
                  canMoveToNextStep: true,
                },
                {
                  component: (
                    <PlanzoneForm
                      formData={formData}
                      error={error}
                      editForm={editForm}
                    />
                  ),
                  title: t("accountCreationConfirmation.planzoneTitle"),
                  placeholder: {
                    previous: t("accountCreationConfirmation.goBack"),
                  },
                  canMoveToNextStep: true,
                },
              ]
            : [
                {
                  component: (
                    <AccountForm
                      formData={formData}
                      error={error}
                      editForm={editForm}
                    />
                  ),
                  title: t("accountCreationConfirmation.accountTitle"),
                  placeholder: {
                    next: t("accountCreationConfirmation.submitAccountForm"),
                  },
                  canMoveToNextStep: true,
                },
              ]
        }
        submit={() => submitForm(formData)}
      />
    </div>
  );
}

export { Form };
